import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask"

export default class extends Controller {
  connect() {
    Inputmask({
      alias: "numeric",
      groupSeparator: ".",
      radixPoint: ",",
      digits: 2,
      digitsOptional: false,
      enforceDigitsOnBlur: true,
      autoGroup: true,
      allowMinus: false,
      rightAlign: false,
      placeholder: "0"
    }).mask(this.element)
  }

  disconnect() {
    this.element.inputmask?.remove()
  }
}
